import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { HttpClient } from '@angular/common/http';
import { coerceNumberProperty } from '@angular/cdk/coercion';
import { HttpHeaders, HttpEventType, HttpRequest, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { User } from '../User';
import { AlertService } from '../alert.service';
import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from '@angular/common';
import { ModalDirective } from 'angular-bootstrap-md';

interface FileReaderEventTarget extends EventTarget {
  result: string
}

interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}


@Component({
  selector: 'app-userdocuments',
  templateUrl: './userdocuments.component.html',
  styleUrls: ['./userdocuments.component.scss']
})

export class UserdocumentsComponent implements OnInit {
   showExtend: boolean = true;
  public buttonContent: any = 'Extend Subscription';

  toggleExtend() {
    this.showExtend = !this.showExtend;
    // CHANGE THE NAME OF THE BUTTON.
    if (this.showExtend)
      this.buttonContent = "Extend Subscription";
    else
      this.buttonContent = "Back";
  }

  private user: User = new User();
  result: any[] = [];
  show: boolean = false;

  tCollapse(): void {
    this.show = !this.show;
  }

  selectedFile: File;
  timeSlots: Array<any> = [];
  public ongoingData: any = [];
  public getCompDetail: any = [];
  public serviceRequestData: any = [];
  subscriptionData: any = {}; // to store the value of subscription booking data
  //getServiceRequest

  // add this varibale for the document upload
  public dlfront = "";
  public dlFrontProgress = 0;
  public dlback = "";
  public dlbackProgress = 0;
  public idproof = "";
  public idproofProgress = 0;
  // end of vehicle upload variable

  private debugData: Boolean = false; // to show and hide the data in console log
  otpErrorMsg: string = ""; // to display the error msg on otp popup
  mobileverifyMsg: string = ""; //shows msg mobile verified or not
  todaydate: Date = new Date(); // to show in the service model request and disable date of before
  uerDlUpdateMsg: string = "";//to display the error msg in DL uplate

  btnTextShow: string = 'View More';
  btnTextHide: string = 'View Less';
  btnText: string = this.btnTextShow;

  constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService, private apiService: ApiService,
    private httpClient: HttpClient, private alertService: AlertService, private datePipe: DatePipe) {
    this.initCustData();
  }

  ngOnInit() {

  }

  initCustData() {
    if (this.apiService.checkUserLoggedIn() == true) {
      let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
      this.httpClient.get(urrr)
        .subscribe(
          data => this.intilizeComponent(data),
          error => this.showError(error)
        );
    } else {
      console.log("User Not Logged In. Please login!")
    }
  }

  intilizeComponent(data) {
    this.user = data;
    this.getOngoing();
     if (this.user.mobileVerified == 0) {
      this.mobileverifyMsg = "mobile not verified";
    }
    else {
      this.mobileverifyMsg = "mobile verified";
    }
  }

  showError(msg) {
    console.log("Error Found in server");
  }
 
  refresh(): void {
    window.location.reload();
  }
  
  getOngoing() {
    if (this.debugData) {
      console.log("OnGoing FUnction : ");
    }
    let getData = { "customer": this.user.id }
    this.httpClient.post(this.apiService.ongoingBooking, getData)
      .subscribe(
        (jdetail: any) => {

          if (this.debugData) {
            console.log("OnGoing API Data: ");
            console.log(jdetail);
          }
          this.ongoingData = jdetail;
          }
      )
  }

  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }

    autoTicks = false;
  disabled = false;
  invert = false;
  showTicks = false;

  get tickInterval(): number | 'auto' {
    return this.showTicks ? (this.autoTicks ? 'auto' : this._tickInterval) : 0;
  }
  set tickInterval(value) {
    this._tickInterval = coerceNumberProperty(value);
  }
  private _tickInterval = 1;


  key: string = 'DLfront';
  key1: string = 'DLback';
  key2: string = 'idProof';


  //______________________________________________________________________________________________
  // start of document upload//
  onSelectFile(event, idType) { // called each time file input changes
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]); // read file as data url
    this.selectedFile = event.target.files[0];
    reader.onload = (event) => { // called once readAsDataURL is completed
      //console.log("data selected loaded");
      this.onUpload(idType);
    }
  }

  onUpload(idTypeA) {
    let urlUploads = this.apiService.postsURL + 'uploadCustomerDoc?id=' + this.user.id + '&key=' + idTypeA;
    if (idTypeA == 'DLfront') {
      urlUploads += '&old=' + this.dlfront;
    } else if (idTypeA == 'DLback') {
      urlUploads += '&old=' + this.dlback;
    } else if (idTypeA == 'idProof') {
      urlUploads += '&old=' + this.idproof;
    }
    const uploadData = new FormData();
    uploadData.append('image', this.selectedFile, this.selectedFile.name);
    this.httpClient.post(urlUploads, uploadData, {
      reportProgress: true,
      observe: 'events'
    }).subscribe(
      event => this.handleUploadProgress(event, idTypeA)
    );
  }


  handleUploadProgress(event, idTypeA) {
    if (event.type === HttpEventType.DownloadProgress) {
      //this.uploadingProgressing = true
      //this.uploadProgress = Math.round(100 * event.loaded / event.total)
    }

    if (event.type === HttpEventType.UploadProgress) {
      if (idTypeA == 'DLfront') {
        this.dlFrontProgress = Math.round(100 * event.loaded / event.total)
      } else if (idTypeA == 'DLback') {
        this.dlbackProgress = Math.round(100 * event.loaded / event.total)
      } else if (idTypeA == 'idProof') {
        this.idproofProgress = Math.round(100 * event.loaded / event.total)
      }
    }

    if (event.type === HttpEventType.Response) {
      if (event.body.status == true) {
        this.intilizeComponent(event.body.customer)
        console.log("uploaded suscessfully");
      } else if (event.body.status == false) {
        console.log("uploaded failed! Try Again.");
      }
      //console.log(event.body)
    }
  }
  // end of doucment upload
  //_____.._________________________________________________________________________________________
  //editMobile: number;

  

  


 
}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/userdocuments/userdocuments.component.ts